import React from 'react';
import { IconArrowsDown, IconArrowsDownLeft, IconArrowsDownRight, IconArrowsLeft, IconArrowsRight, IconArrowsUp, IconArrowsUpLeft, IconArrowsUpRight } from '@carnica/graphics';
export var IconArrow = function IconArrow(_ref) {
  var direction = _ref.direction,
    color = _ref.color;
  switch (direction) {
    case 'down':
      return /*#__PURE__*/React.createElement(IconArrowsDown, {
        color: color,
        size: 16,
        "data-t-id": "components-ButtonArrow"
      });
    case 'left':
      return /*#__PURE__*/React.createElement(IconArrowsLeft, {
        color: color,
        size: 16
      });
    case 'right':
      return /*#__PURE__*/React.createElement(IconArrowsRight, {
        color: color,
        size: 16
      });
    case 'up':
      return /*#__PURE__*/React.createElement(IconArrowsUp, {
        color: color,
        size: 16
      });
    case 'top-left':
      return /*#__PURE__*/React.createElement(IconArrowsUpLeft, {
        color: color,
        size: 16
      });
    case 'top-right':
      return /*#__PURE__*/React.createElement(IconArrowsUpRight, {
        color: color,
        size: 16
      });
    case 'bottom-left':
      return /*#__PURE__*/React.createElement(IconArrowsDownLeft, {
        color: color,
        size: 16
      });
    case 'bottom-right':
      return /*#__PURE__*/React.createElement(IconArrowsDownRight, {
        color: color,
        size: 16
      });
    default:
      return null;
  }
};